export default __webpack_public_path__ + "static/transaction-transitions-v2-8e077ca02bcb34fbf111f2f004b6a3d5.png";